import configData from "../configuration.json";

export default function Header() {
    return (
        <div className="header" style={{display: "none"}}>{configData.VERSION_TAG}</div>
    );
}